import Box from '@sendsprint/ui-react/dist/components/Box';
import React, { ReactNode } from 'react';
import FaSpinner from '@src/assets/svgs/transformed/react-icons/fa/FaSpinner';

export type Table2Props = {
  children?: ReactNode;
  isFetching?: boolean;
};

const Table2 = ({ children, isFetching }: Table2Props) => {
  return (
    <Box className="ss-bg-white ss-relative ss-min-h-[400px] ss-w-full ss-py-3 ss-rounded-lg">
      {isFetching && (
        <FaSpinner
          width={24}
          height={24}
          className="ss-absolute ss-fill-primary1-400 ss-animate-spin ss-top-2 ss-right-2"
        />
      )}
      {children}
    </Box>
  );
};

export default Table2;
